import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { AlertSearchSchema } from './-zod-schema';
export const Route = createFileRoute('/_staff/wage-ledger/_layout/alerts/')({
  validateSearch: zodValidator(AlertSearchSchema)
});